<!-- [팝업] 관심 컨텐츠 유형 선택 -->
<template>
  <b-modal
    v-model="showInterestContentSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="적용"
    cancel-title="취소"
    size="lg"
    title="관심 컨텐츠 유형 선택"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row class="mt-1">
      <b-table
        ref="refInterestContentTable"
        primary-key="id"
        :items="fetchData"
        :fields="selectTableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        class="position-relative"
      >
        <template #cell(select)="data">
          <div
            style="text-align: center;"
          >
            <b-form-checkbox
              :id="`content-checkbox-${data.item.id}`"
              v-model="selectedContent"
              :value="data.item"
              name="content-checkbox"
            />
          </div>
        </template>
        <template #cell(title)="data">
          <label
            :for="`content-checkbox-${data.item.id}`"
            class="content-label"
          >
            <div>{{ data.item.title }}</div>
            <small>{{ data.item.description }}</small>
          </label>
        </template>
      </b-table>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  ref, onMounted,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'

export default {
  components: {
  },

  props: {
    showInterestContentSelect: {
      type: Boolean,
      required: true,
    },
    selectedValue: {
      type: String,
      required: false,
      default: null,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const selectedContent = ref([])
    // const allItems = ref([])

    // Main Table Config
    const refInterestContentTable = ref(null)
    const sortBy = ref('createDate')
    const isSortDesc = ref(false)

    const selectTableColumns = [
      {
        key: 'select', label: '선택', sortable: false, thStyle: { width: '11%', textAlign: 'center' },
      },
      {
        key: 'title', label: '항목', sortable: false, thStyle: { width: 'auto' },
      },
    ]
    // Main Table Config End.

    const fetchData = (ctx, callback) => {
      axios.post('/fa/interest-content/list', {
        search: {},
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
      })
        .then(rs => {
          const { items } = rs.data
          // allItems.value = items
          callback(items)

          if (props.selectedValue && props.selectedValue.length > 0) {
            const selectedIds = props.selectedValue.split(',').map(id => Number(id.trim()))
            selectedContent.value = items.filter(item => selectedIds.includes(item.id))
          }
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터 조회에 실패하였습니다."))
        })
    }

    const refetchData = () => {
      refInterestContentTable.value.refresh()
    }

    const close = () => {
      emit('close', null)
      clear()
    }

    const submit = () => {
      if (selectedContent.value.length === 0) {
        pushToast('warning', '컨텐츠를 선택하세요')
        return
      }
      // id 오름차순
      const sorted = [...selectedContent.value].sort((a, b) => a.id - b.id)
      emit('close', sorted)
      clear()
    }

    const clear = () => {
      selectedContent.value = []
    }

    return {
      close,
      submit,
      refInterestContentTable,
      sortBy,
      isSortDesc,
      selectTableColumns,
      fetchData,
      refetchData,
      selectedContent,
    }
  },
}
</script>

<style scoped>
.content-label {
  font-size: inherit;
  display: block;
  width: 100%;
  cursor: pointer;
}
</style>
